module.exports = __webpack_public_path__ + "public/Icons/twitter.png?9cfbe0bb";